import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { MESSENGER_TAB_STATE } from 'app/constants/launcherContentStates'
import useDelayUnmount from 'app/hooks/useDelayUnmount'
import DepartmentsList from './components/Departments'
import FistChat from '../../../firstChat/main'
import './messenger.scss'

const getMessengerTabState = ({ widgetData }) => widgetData.widgetInfo.messengerTabState

const Messenger = ({ ct }) => {
  const messengerTabState = useSelector(getMessengerTabState)

  const [isMounted, setIsMounted] = useState(ct === 1)
  const shouldRenderChild = useDelayUnmount(isMounted, 200)

  useEffect(() => {
    if (ct !== 1) {
      setIsMounted(false)
    } else {
      setIsMounted(true)
    }
  }, [ct])

  if (!shouldRenderChild) return null

  return (
    <div className={`${isMounted ? 'component_enter' : 'component_exit'} messanger_wrapper`}>
      {messengerTabState === MESSENGER_TAB_STATE.CHAT && <FistChat />}
      {messengerTabState === MESSENGER_TAB_STATE.DEPARTMENTS && <DepartmentsList />}
    </div>
  )
}

export default Messenger
